import React from 'react';
import { Button, Flex, Input, theme } from 'antd';
import { ClearOutlined, ReloadOutlined } from '@ant-design/icons';

import { PAGES_URL_SEARCH_MIN_LENGTH } from './usePagesUrlSearch';

const PAGES_TOOLBAR_STRINGS = {
  filterPlaceholder: `Contains (enter at least ${PAGES_URL_SEARCH_MIN_LENGTH} characters)`,
  filterAriaLabel: 'Filter pages by URL',
  refresh: 'Refresh',
  clearFilters: 'Clear filters',
};

export type PagesToolbarProps = {
  searchText: string;
  onSearchChange: (text: string) => void;
  onRefresh: () => void;
  onClearFilters: () => void;
};

function PagesToolbar({ searchText, onSearchChange, onRefresh, onClearFilters }: PagesToolbarProps) {
  const { token } = theme.useToken();

  return (
    <Flex gap={token.marginXS} align="center" wrap>
      <Input.Search
        placeholder={PAGES_TOOLBAR_STRINGS.filterPlaceholder}
        aria-label={PAGES_TOOLBAR_STRINGS.filterAriaLabel}
        value={searchText}
        onChange={(event) => onSearchChange(event.target.value)}
        minLength={PAGES_URL_SEARCH_MIN_LENGTH}
        // FIXME: no exact token — the prototype fixes the input at 340px.
        style={{ width: 340 }}
        allowClear
      />
      <Button icon={<ReloadOutlined />} onClick={onRefresh}>
        {PAGES_TOOLBAR_STRINGS.refresh}
      </Button>
      <Button icon={<ClearOutlined />} onClick={onClearFilters}>
        {PAGES_TOOLBAR_STRINGS.clearFilters}
      </Button>
    </Flex>
  );
}

export default PagesToolbar;
